import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMartinique = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1322)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.8971 10.4347C23.5661 7.90415 22.4294 5.45886 20.4852 3.51472C18.5411 1.57058 16.0958 0.433815 13.5652 0.102783L13.5652 10.4347H23.8971Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4347 0.102783C7.90415 0.433815 5.45882 1.57053 3.51468 3.51468C1.57058 5.45886 0.433815 7.90419 0.102783 10.4348L10.4348 10.4348L10.4347 0.102783Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.102783 13.5652C0.433815 16.0958 1.57058 18.5412 3.51468 20.4853C5.45882 22.4294 7.9041 23.5661 10.4348 23.8973L10.4347 13.5653L0.102783 13.5652Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.5652 23.8972C16.0958 23.5661 18.5411 22.4294 20.4853 20.4853C22.4294 18.5411 23.5661 16.0958 23.8972 13.5652H13.5652V23.8972Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.0964 7.61428C16.0964 7.45472 16.2261 7.32502 16.3857 7.32502H17.0056C17.9854 7.32502 18.7826 6.52786 18.7826 5.54803C18.7826 4.56821 17.9855 3.771 17.0056 3.771H16.4169C16.2248 3.62667 15.967 3.53766 15.6827 3.53766C15.0895 3.53766 14.6088 3.92227 14.6088 4.39674C14.6088 4.86661 15.0804 5.2478 15.6655 5.25521L15.6653 5.25863H17.0056C17.1652 5.25863 17.2949 5.38838 17.2949 5.54794C17.2949 5.7075 17.1652 5.83721 17.0056 5.83721H16.3857C15.4058 5.83721 14.6087 6.63436 14.6087 7.61419C14.6087 8.59402 15.4058 9.39122 16.3857 9.39122H18.7826V7.9035H16.3857C16.2261 7.90355 16.0964 7.77385 16.0964 7.61428Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.70509 7.61428C6.70509 7.45472 6.8348 7.32502 6.99441 7.32502H7.61428C8.59416 7.32502 9.39136 6.52786 9.39136 5.54803C9.39136 4.56821 8.5942 3.771 7.61428 3.771H7.02562C6.83348 3.62667 6.57572 3.53766 6.29137 3.53766C5.69827 3.53766 5.21747 3.92227 5.21747 4.39674C5.21747 4.86661 5.68908 5.2478 6.27427 5.25521L6.27398 5.25863H7.61433C7.77394 5.25863 7.90364 5.38838 7.90364 5.54794C7.90364 5.7075 7.77394 5.83721 7.61433 5.83721H6.99445C6.01458 5.83721 5.21747 6.63436 5.21747 7.61419C5.21747 8.59402 6.01453 9.39122 6.99445 9.39122H9.39131V7.9035H6.99441C6.8348 7.90355 6.70509 7.77385 6.70509 7.61428Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.0964 18.6853C16.0964 18.5258 16.2261 18.3961 16.3857 18.3961H17.0055C17.9854 18.3961 18.7826 17.5989 18.7826 16.6191C18.7826 15.6393 17.9855 14.842 17.0055 14.842H16.4169C16.2248 14.6977 15.967 14.6087 15.6826 14.6087C15.0895 14.6087 14.6087 14.9934 14.6087 15.4678C14.6087 15.9377 15.0803 16.3188 15.6655 16.3263L15.6652 16.3297H17.0055C17.1651 16.3297 17.2948 16.4594 17.2948 16.619C17.2948 16.7785 17.1651 16.9083 17.0055 16.9083H16.3856C15.4058 16.9083 14.6086 17.7054 14.6086 18.6852C14.6086 19.6651 15.4057 20.4623 16.3856 20.4623H18.7826V18.9746H16.3857C16.2261 18.9746 16.0964 18.8448 16.0964 18.6853Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.70508 18.6853C6.70508 18.5258 6.83478 18.3961 6.99439 18.3961H7.61427C8.59414 18.3961 9.39134 17.5989 9.39134 16.6191C9.39134 15.6393 8.59419 14.842 7.61427 14.842H7.02561C6.83347 14.6977 6.5757 14.6087 6.29136 14.6087C5.6982 14.6087 5.21741 14.9934 5.21741 15.4678C5.21741 15.9377 5.68902 16.3188 6.2742 16.3263L6.27392 16.3297H7.61427C7.77388 16.3297 7.90358 16.4594 7.90358 16.619C7.90358 16.7785 7.77388 16.9083 7.61427 16.9083H6.99439C6.01452 16.9083 5.21741 17.7054 5.21741 18.6852C5.21741 19.6651 6.01447 20.4623 6.99439 20.4623H9.3913V18.9746H6.99439C6.83478 18.9746 6.70508 18.8448 6.70508 18.6853Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1322",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgMartinique;
